// Extra booking-flow strings (success inbox note, cash-fallback, flight status)
// for all 14 supported languages. Merged into TRANSLATIONS in translations.js.
export const BOOKING_EXTRA_STRINGS = {
  de: {
    bp_check_inbox: "Vielen Dank für Ihre Bestellung. Bitte prüfen Sie Ihren Posteingang oder den Spam-Ordner.",
    bp_pay_cash_instead: "Stattdessen bar bezahlen",
    bp_cancel_payment: "Zahlung abbrechen",
    bp_flight_check: "Flugstatus prüfen",
    bp_flight_checking: "Flug wird geprüft…",
    bp_flight_not_found: "Flug nicht gefunden. Bitte Flugnummer prüfen.",
    bp_flight_arr: "Ankunft", bp_flight_dep: "Abflug",
    bp_fs_scheduled: "Planmäßig", bp_fs_active: "In der Luft", bp_fs_landed: "Gelandet",
    bp_fs_cancelled: "Annulliert", bp_fs_delayed: "Verspätet", bp_fs_diverted: "Umgeleitet",
    bp_fs_incident: "Zwischenfall", bp_fs_unknown: "Unbekannt",
  },
  en: {
    bp_check_inbox: "Thank you for your order. Please check your inbox or spam folder.",
    bp_pay_cash_instead: "Pay with cash instead",
    bp_cancel_payment: "Cancel payment",
    bp_flight_check: "Check flight status",
    bp_flight_checking: "Checking flight…",
    bp_flight_not_found: "Flight not found. Please check the flight number.",
    bp_flight_arr: "Arrival", bp_flight_dep: "Departure",
    bp_fs_scheduled: "Scheduled", bp_fs_active: "In the air", bp_fs_landed: "Landed",
    bp_fs_cancelled: "Cancelled", bp_fs_delayed: "Delayed", bp_fs_diverted: "Diverted",
    bp_fs_incident: "Incident", bp_fs_unknown: "Unknown",
  },
  fr: {
    bp_check_inbox: "Merci pour votre commande. Veuillez vérifier votre boîte de réception ou votre dossier spam.",
    bp_pay_cash_instead: "Payer en espèces à la place",
    bp_cancel_payment: "Annuler le paiement",
    bp_flight_check: "Vérifier le statut du vol",
    bp_flight_checking: "Vérification du vol…",
    bp_flight_not_found: "Vol introuvable. Veuillez vérifier le numéro de vol.",
    bp_flight_arr: "Arrivée", bp_flight_dep: "Départ",
    bp_fs_scheduled: "Prévu", bp_fs_active: "En vol", bp_fs_landed: "Atterri",
    bp_fs_cancelled: "Annulé", bp_fs_delayed: "Retardé", bp_fs_diverted: "Dérouté",
    bp_fs_incident: "Incident", bp_fs_unknown: "Inconnu",
  },
  it: {
    bp_check_inbox: "Grazie per il tuo ordine. Controlla la tua casella di posta o la cartella spam.",
    bp_pay_cash_instead: "Paga invece in contanti",
    bp_cancel_payment: "Annulla il pagamento",
    bp_flight_check: "Verifica stato del volo",
    bp_flight_checking: "Verifica del volo…",
    bp_flight_not_found: "Volo non trovato. Controlla il numero del volo.",
    bp_flight_arr: "Arrivo", bp_flight_dep: "Partenza",
    bp_fs_scheduled: "Programmato", bp_fs_active: "In volo", bp_fs_landed: "Atterrato",
    bp_fs_cancelled: "Annullato", bp_fs_delayed: "In ritardo", bp_fs_diverted: "Dirottato",
    bp_fs_incident: "Incidente", bp_fs_unknown: "Sconosciuto",
  },
  es: {
    bp_check_inbox: "Gracias por su pedido. Revise su bandeja de entrada o la carpeta de spam.",
    bp_pay_cash_instead: "Pagar en efectivo en su lugar",
    bp_cancel_payment: "Cancelar el pago",
    bp_flight_check: "Comprobar estado del vuelo",
    bp_flight_checking: "Comprobando vuelo…",
    bp_flight_not_found: "Vuelo no encontrado. Compruebe el número de vuelo.",
    bp_flight_arr: "Llegada", bp_flight_dep: "Salida",
    bp_fs_scheduled: "Programado", bp_fs_active: "En vuelo", bp_fs_landed: "Aterrizado",
    bp_fs_cancelled: "Cancelado", bp_fs_delayed: "Retrasado", bp_fs_diverted: "Desviado",
    bp_fs_incident: "Incidente", bp_fs_unknown: "Desconocido",
  },
  pt: {
    bp_check_inbox: "Obrigado pelo seu pedido. Verifique a sua caixa de entrada ou a pasta de spam.",
    bp_pay_cash_instead: "Pagar em dinheiro",
    bp_cancel_payment: "Cancelar pagamento",
    bp_flight_check: "Verificar estado do voo",
    bp_flight_checking: "A verificar o voo…",
    bp_flight_not_found: "Voo não encontrado. Verifique o número do voo.",
    bp_flight_arr: "Chegada", bp_flight_dep: "Partida",
    bp_fs_scheduled: "Programado", bp_fs_active: "Em voo", bp_fs_landed: "Aterrou",
    bp_fs_cancelled: "Cancelado", bp_fs_delayed: "Atrasado", bp_fs_diverted: "Desviado",
    bp_fs_incident: "Incidente", bp_fs_unknown: "Desconhecido",
  },
  tr: {
    bp_check_inbox: "Siparişiniz için teşekkürler. Lütfen gelen kutunuzu veya spam klasörünüzü kontrol edin.",
    bp_pay_cash_instead: "Bunun yerine nakit öde",
    bp_cancel_payment: "Ödemeyi iptal et",
    bp_flight_check: "Uçuş durumunu kontrol et",
    bp_flight_checking: "Uçuş kontrol ediliyor…",
    bp_flight_not_found: "Uçuş bulunamadı. Lütfen uçuş numarasını kontrol edin.",
    bp_flight_arr: "Varış", bp_flight_dep: "Kalkış",
    bp_fs_scheduled: "Planlandı", bp_fs_active: "Havada", bp_fs_landed: "İndi",
    bp_fs_cancelled: "İptal edildi", bp_fs_delayed: "Rötarlı", bp_fs_diverted: "Yönlendirildi",
    bp_fs_incident: "Olay", bp_fs_unknown: "Bilinmiyor",
  },
  ru: {
    bp_check_inbox: "Спасибо за ваш заказ. Пожалуйста, проверьте папку «Входящие» или «Спам».",
    bp_pay_cash_instead: "Оплатить наличными",
    bp_cancel_payment: "Отменить оплату",
    bp_flight_check: "Проверить статус рейса",
    bp_flight_checking: "Проверка рейса…",
    bp_flight_not_found: "Рейс не найден. Проверьте номер рейса.",
    bp_flight_arr: "Прибытие", bp_flight_dep: "Вылет",
    bp_fs_scheduled: "По расписанию", bp_fs_active: "В воздухе", bp_fs_landed: "Приземлился",
    bp_fs_cancelled: "Отменён", bp_fs_delayed: "Задержан", bp_fs_diverted: "Перенаправлен",
    bp_fs_incident: "Инцидент", bp_fs_unknown: "Неизвестно",
  },
  ar: {
    bp_check_inbox: "شكرًا لطلبك. يرجى التحقق من صندوق الوارد أو مجلد البريد المزعج.",
    bp_pay_cash_instead: "الدفع نقدًا بدلاً من ذلك",
    bp_cancel_payment: "إلغاء الدفع",
    bp_flight_check: "التحقق من حالة الرحلة",
    bp_flight_checking: "جارٍ التحقق من الرحلة…",
    bp_flight_not_found: "لم يتم العثور على الرحلة. يرجى التحقق من رقم الرحلة.",
    bp_flight_arr: "الوصول", bp_flight_dep: "المغادرة",
    bp_fs_scheduled: "مجدولة", bp_fs_active: "في الجو", bp_fs_landed: "هبطت",
    bp_fs_cancelled: "ملغاة", bp_fs_delayed: "متأخرة", bp_fs_diverted: "محولة",
    bp_fs_incident: "حادث", bp_fs_unknown: "غير معروف",
  },
  fa: {
    bp_check_inbox: "از سفارش شما متشکریم. لطفاً صندوق ورودی یا پوشه اسپم خود را بررسی کنید.",
    bp_pay_cash_instead: "به جای آن نقدی پرداخت کنید",
    bp_cancel_payment: "لغو پرداخت",
    bp_flight_check: "بررسی وضعیت پرواز",
    bp_flight_checking: "در حال بررسی پرواز…",
    bp_flight_not_found: "پرواز یافت نشد. لطفاً شماره پرواز را بررسی کنید.",
    bp_flight_arr: "ورود", bp_flight_dep: "خروج",
    bp_fs_scheduled: "طبق برنامه", bp_fs_active: "در هوا", bp_fs_landed: "نشسته",
    bp_fs_cancelled: "لغو شده", bp_fs_delayed: "با تأخیر", bp_fs_diverted: "منحرف شده",
    bp_fs_incident: "حادثه", bp_fs_unknown: "نامشخص",
  },
  hi: {
    bp_check_inbox: "आपके ऑर्डर के लिए धन्यवाद। कृपया अपना इनबॉक्स या स्पैम फ़ोल्डर जांचें।",
    bp_pay_cash_instead: "इसके बजाय नकद भुगतान करें",
    bp_cancel_payment: "भुगतान रद्द करें",
    bp_flight_check: "उड़ान की स्थिति जांचें",
    bp_flight_checking: "उड़ान जांची जा रही है…",
    bp_flight_not_found: "उड़ान नहीं मिली। कृपया उड़ान संख्या जांचें।",
    bp_flight_arr: "आगमन", bp_flight_dep: "प्रस्थान",
    bp_fs_scheduled: "निर्धारित", bp_fs_active: "हवा में", bp_fs_landed: "उतर गई",
    bp_fs_cancelled: "रद्द", bp_fs_delayed: "विलंबित", bp_fs_diverted: "मोड़ी गई",
    bp_fs_incident: "घटना", bp_fs_unknown: "अज्ञात",
  },
  zh: {
    bp_check_inbox: "感谢您的订单。请查看您的收件箱或垃圾邮件文件夹。",
    bp_pay_cash_instead: "改为现金支付",
    bp_cancel_payment: "取消付款",
    bp_flight_check: "查询航班状态",
    bp_flight_checking: "正在查询航班…",
    bp_flight_not_found: "未找到航班。请检查航班号。",
    bp_flight_arr: "到达", bp_flight_dep: "出发",
    bp_fs_scheduled: "按计划", bp_fs_active: "飞行中", bp_fs_landed: "已降落",
    bp_fs_cancelled: "已取消", bp_fs_delayed: "延误", bp_fs_diverted: "改航",
    bp_fs_incident: "事故", bp_fs_unknown: "未知",
  },
  ko: {
    bp_check_inbox: "주문해 주셔서 감사합니다. 받은 편지함 또는 스팸 폴더를 확인해 주세요.",
    bp_pay_cash_instead: "대신 현금으로 결제",
    bp_cancel_payment: "결제 취소",
    bp_flight_check: "항공편 상태 확인",
    bp_flight_checking: "항공편 확인 중…",
    bp_flight_not_found: "항공편을 찾을 수 없습니다. 항공편 번호를 확인해 주세요.",
    bp_flight_arr: "도착", bp_flight_dep: "출발",
    bp_fs_scheduled: "예정", bp_fs_active: "비행 중", bp_fs_landed: "착륙",
    bp_fs_cancelled: "취소됨", bp_fs_delayed: "지연", bp_fs_diverted: "회항",
    bp_fs_incident: "사고", bp_fs_unknown: "알 수 없음",
  },
  ckb: {
    bp_check_inbox: "سوپاس بۆ داواکارییەکەت. تکایە سندووقی هاتووەکان یان فۆڵدەری سپام بپشکنە.",
    bp_pay_cash_instead: "لەجیاتی ئەوە بە نەقد بدە",
    bp_cancel_payment: "پاشگەزبوونەوە لە پارەدان",
    bp_flight_check: "پشکنینی دۆخی فڕین",
    bp_flight_checking: "فڕین دەپشکنرێت…",
    bp_flight_not_found: "فڕین نەدۆزرایەوە. تکایە ژمارەی فڕین بپشکنە.",
    bp_flight_arr: "گەیشتن", bp_flight_dep: "هەڵفڕین",
    bp_fs_scheduled: "بەپلان", bp_fs_active: "لە ئاسماندایە", bp_fs_landed: "نیشتەوە",
    bp_fs_cancelled: "هەڵوەشاوەتەوە", bp_fs_delayed: "دواکەوتووە", bp_fs_diverted: "ڕێگا گۆڕدراوە",
    bp_fs_incident: "ڕووداو", bp_fs_unknown: "نەزانراو",
  },
};

// Auto pickup-time + flight delay notes (all langs). {time} and {min} interpolated.
export const FLIGHT_PICKUP_STRINGS = {
  de: { bp_pickup_set: "Abholzeit auf {time} gesetzt (Ankunft + 60 Min.)", bp_flight_delayed: "Verspätet um {min} Min.", bp_flight_early: "{min} Min. früher", bp_flight_ontime: "Pünktlich" },
  en: { bp_pickup_set: "Pickup time set to {time} (arrival + 60 min)", bp_flight_delayed: "Delayed by {min} min", bp_flight_early: "{min} min early", bp_flight_ontime: "On time" },
  fr: { bp_pickup_set: "Heure de prise en charge fixée à {time} (arrivée + 60 min)", bp_flight_delayed: "Retard de {min} min", bp_flight_early: "{min} min en avance", bp_flight_ontime: "À l'heure" },
  it: { bp_pickup_set: "Orario di ritiro impostato alle {time} (arrivo + 60 min)", bp_flight_delayed: "In ritardo di {min} min", bp_flight_early: "{min} min in anticipo", bp_flight_ontime: "In orario" },
  es: { bp_pickup_set: "Hora de recogida fijada a las {time} (llegada + 60 min)", bp_flight_delayed: "Retraso de {min} min", bp_flight_early: "{min} min antes", bp_flight_ontime: "A tiempo" },
  pt: { bp_pickup_set: "Hora de recolha definida para {time} (chegada + 60 min)", bp_flight_delayed: "Atraso de {min} min", bp_flight_early: "{min} min mais cedo", bp_flight_ontime: "A horas" },
  tr: { bp_pickup_set: "Alış saati {time} olarak ayarlandı (varış + 60 dk)", bp_flight_delayed: "{min} dk gecikmeli", bp_flight_early: "{min} dk erken", bp_flight_ontime: "Zamanında" },
  ru: { bp_pickup_set: "Время подачи установлено на {time} (прибытие + 60 мин)", bp_flight_delayed: "Задержка на {min} мин", bp_flight_early: "На {min} мин раньше", bp_flight_ontime: "По расписанию" },
  ar: { bp_pickup_set: "تم تحديد وقت الاستلام على {time} (الوصول + 60 دقيقة)", bp_flight_delayed: "متأخرة {min} دقيقة", bp_flight_early: "أبكر بـ {min} دقيقة", bp_flight_ontime: "في الموعد" },
  fa: { bp_pickup_set: "زمان سوار شدن روی {time} تنظیم شد (ورود + ۶۰ دقیقه)", bp_flight_delayed: "{min} دقیقه تأخیر", bp_flight_early: "{min} دقیقه زودتر", bp_flight_ontime: "به‌موقع" },
  hi: { bp_pickup_set: "पिकअप समय {time} पर सेट (आगमन + 60 मिनट)", bp_flight_delayed: "{min} मिनट देरी", bp_flight_early: "{min} मिनट पहले", bp_flight_ontime: "समय पर" },
  zh: { bp_pickup_set: "接送时间已设为 {time}（到达 + 60 分钟）", bp_flight_delayed: "延误 {min} 分钟", bp_flight_early: "提前 {min} 分钟", bp_flight_ontime: "准点" },
  ko: { bp_pickup_set: "픽업 시간이 {time}로 설정됨 (도착 + 60분)", bp_flight_delayed: "{min}분 지연", bp_flight_early: "{min}분 빠름", bp_flight_ontime: "정시" },
  ckb: { bp_pickup_set: "کاتی وەرگرتن ڕێکخرا بۆ {time} (گەیشتن + ٦٠ خولەک)", bp_flight_delayed: "دواکەوتووە بە {min} خولەک", bp_flight_early: "{min} خولەک زووتر", bp_flight_ontime: "لە کاتی خۆیدا" },
};
